import {
  EVENT_FORM,
  getAppointmentModalityOptions,
  getAppointmentOptions,
  getChangeOriginOptions,
  getChangeReasonOptions,
  getSRAppointmentOptions,
} from '../../common'
import { SRInput, SRTimeInput, SRSearchSelect, SRFormAdress } from '@sr/ui'
import { useModalContext } from '../../provider'
import { FORM_TYPE, Label } from '@shared/ui'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { APPOINTMENT_MODALITY, APPOINTMENT_TYPES } from '@shared/data-access'
import { useFormContext } from 'react-hook-form'

import { InputSelect } from '@shared/storybook'

export const CareForm = observer(
  ({
    isCoordinator,
    isReadOnly,
    isEdit,
    policyClients = [],
    isEditing,
    needsTracking,
    searchSelectProps,
    officeStreet,
    showSocialReferentSelect = false,
    socialReferentOptions = [],
  }) => {
    const { t } = useTranslation()
    const { appointmentType, noDigital, street, officeControl, modality, } =
      useModalContext()
    const { watch } = useFormContext()

    const formAppointmentType = watch(EVENT_FORM.appointmentType)
    const currentAppointmentType = formAppointmentType || appointmentType
    const appointmentTypes =
      isCoordinator || isReadOnly
        ? getAppointmentOptions(isEdit)
        : getSRAppointmentOptions(isEdit)

    const policiesEmptyError =
      !policyClients.length && t('agenda.formModal.formError.noUserList')

    const defaultLabel = t('agenda.formModal.labels.userList')

    const isBlocked = isEdit && !isEditing
    const disableSocialReferentSelect =
      socialReferentOptions.length <= 1 || isReadOnly || isBlocked
    const noMoreSocialReferentsMessage = disableSocialReferentSelect
      ? t('agenda.formModal.noMoreSocialReferents')
      : null

    const hasToAddReason = needsTracking && isEditing
    return (
      <>
        <InputSelect
          name={EVENT_FORM.appointmentType}
          options={appointmentTypes}
          disabled={isReadOnly || isBlocked}
        />
        <InputSelect
          name={EVENT_FORM.appointmentModality}
          options={getAppointmentModalityOptions(currentAppointmentType)}
          disabled={isReadOnly || isBlocked}
        />
        <SRInput
          name={EVENT_FORM.appointmentDay}
          type={FORM_TYPE.date}
          min={new Date().toISOString().split('T')[0]}
          disabled={isReadOnly || isBlocked}
          isAxis={true}
        />
        <SRTimeInput
          startName={EVENT_FORM.startDate}
          endName={EVENT_FORM.endDate}
          disabled={isReadOnly || isBlocked}
          isAxis={true}
        />
        {showSocialReferentSelect && isCoordinator && (
          <>
            <Label
              className="text-sm " label={t('agenda.formModal.labels.socialReferent')} />
            <InputSelect
              name={EVENT_FORM.appointmentSocialReferent}
              options={socialReferentOptions}
              disabled={disableSocialReferentSelect}
            />
            {isEditing && noMoreSocialReferentsMessage && (
              <div className="text-xs text-gray-500 mt-1">
                {noMoreSocialReferentsMessage}
              </div>
            )}
          </>
        )}
        <Label
          className="text-sm " label={t("agenda.formModal.labels.clientName")} />
        <SRSearchSelect
          {...searchSelectProps}
          name={EVENT_FORM.appointmentPolicy}
          options={policyClients}
          disabled={isBlocked || isReadOnly || isEdit}
          emptyError={policiesEmptyError}
          defaultLabel={defaultLabel}
          isAxis={true}
        />

        {hasToAddReason && (
          <>
            <InputSelect
              name={EVENT_FORM.changeOrigin}
              options={getChangeOriginOptions()}
              disabled={isReadOnly || isBlocked}
              placeholder={t('agenda.formModal.placeholder.changeOrigin')}
            />
            <InputSelect
              name={EVENT_FORM.changeReason}
              options={getChangeReasonOptions()}
              disabled={isReadOnly || isBlocked}
              placeholder={t('agenda.formModal.placeholder.changeReason')}
            />
          </>
        )}
        {(noDigital ||
          (appointmentType === APPOINTMENT_TYPES.INITIAL_ANALYSIS &&
            modality === APPOINTMENT_MODALITY.faceToFace)) && (
            <SRFormAdress
              officeControl={officeControl}
              officeAddress={officeStreet}
              homeAddress={street}
              isAxis={true}
            />
          )}
      </>
    )
  },
)
